import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';
import type { AssignPlanRequest } from '@/types/tenant-credit-plan.types';

/**
 * Tenant ↔ credit-plan mapping API (management-only). Each call returns the backend
 * ResultEntity (`{ success, data }`); callers read `.data`.
 */
class TenantCreditPlanService {
  async list(search?: string) {
    const response = await apiClient.post(API_ENDPOINTS.TENANT_CREDIT_PLAN.LIST, { search: search?.trim() || undefined });
    return response.data;
  }

  async assign(payload: AssignPlanRequest) {
    const response = await apiClient.post(API_ENDPOINTS.TENANT_CREDIT_PLAN.ASSIGN, payload);
    return response.data;
  }

  async unassign(tenant_key: string) {
    const response = await apiClient.post(API_ENDPOINTS.TENANT_CREDIT_PLAN.UNASSIGN, { tenant_key });
    return response.data;
  }
}

export const tenantCreditPlanService = new TenantCreditPlanService();
